import {
  HomeState,
  UpdatePartialResponseProp,
  commonButtonMessages,
  homeOnboardingSelfMifidSurveyMessages,
  useAppSelector,
  useMifidSurveyLogic,
  useWebCollaborationLogic
} from 'azshared';
import { FormThematicAreaResponse } from 'azshared/src/lib/api/generated/prometeia/api';
import React, { RefObject, useRef } from 'react';
import { useIntl } from 'react-intl';
import { AppButton, AppButtonType } from '../../../../components/buttons/app-button';
import { Card, CardSize } from '../../../../components/card/card';
import { AppHeader } from '../../../../components/header/header';
import { useGlobalActions } from '../../../../hooks/global-actions';

import './mifid-survey-page.scss';
import { MifidSection } from './components/mifid-section';
import { WebCollaborationOverlay } from '../../../../components/web-collaboration-overlay/web-collaboration-overlay';
import { GetTasksResponseMifidStateEnum } from 'azshared/src/lib/api/generated';

export const EXCLUDED_CLASS_MIFID = ['content', 'app-menu-bar'];
export const EXCLUDED_PREFIX_CLASS_MIFID = [
  'web-collaboration-overlay',
  'wait-for-cf-dialog',
  'web-collaboration-sharing-block-dialog',
  'wait-for-other-user-dialog',
  'web-collaboration-permission-requests-dialog',
  'MuiDialog',
  'MuiPaper-root'
];

export interface MifidSectionBodyProps {
  questionnaire: FormThematicAreaResponse | undefined;
  onSave: (props: UpdatePartialResponseProp[]) => void;
}

export const MifidSurveyPage = () => {
  const { formatMessage } = useIntl();
  const globalActions = useGlobalActions();
  const { template, form, orderSections, onSubmit, isLoading } = useMifidSurveyLogic(globalActions);
  const refPageMifid: RefObject<HTMLDivElement> = useRef(null);
  const { roomId } = useWebCollaborationLogic(globalActions);
  const { toDoActivities } = useAppSelector((state) => state.features.home as HomeState);

  const isReadOnly = toDoActivities?.value?.mifidState === GetTasksResponseMifidStateEnum.Completed;

  return (
    <div className='mifid-survey-page'>
      <AppHeader />
      <div className='mifid-survey-page-content' ref={refPageMifid}>
        <h2>{formatMessage(homeOnboardingSelfMifidSurveyMessages.cardTitle)}</h2>
        {template && (
          <>
            <Card sizeVariant={CardSize.MAXI}>
              {template.sezioni
                ?.filter((s) => !s.idSezione?.startsWith('HEADER'))
                ?.sort(orderSections)
                ?.map((section) => (
                  <MifidSection key={section.idSezione} section={section} form={form} readonly={isReadOnly} />
                ))}
            </Card>
            <div className='actions'>
              <AppButton
                loading={isLoading}
                className={'mifid-survey-page-confirm-button'}
                type={AppButtonType.SUBMIT}
                label={formatMessage(commonButtonMessages.confirm)}
                onClick={onSubmit}
                disabled={isReadOnly || !form.formState.isValid || isLoading}
              />
            </div>
          </>
        )}
      </div>
      {roomId && <WebCollaborationOverlay />}
    </div>
  );
};
